import React from "react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { utcTimeAgo } from "../../../utils/utcTime";
import { appendVqqLocation, formatVqqName } from "../../../utils/vqqNameFormat";

// Builds the panel's contextual message: "You submitted your responses to {Past VQQ} for
// {Past Sponsor} {time ago}, which uses the same questionnaire. Autorelease accepts ...
// Click here to view and verify your last submitted responses."
// A template keeps its id when it is renamed, so the past VQQ can carry another name than this
// request. The message names the VQQ Autorelease would release, and falls back to the request's
// name only when the past submission carries none.
const AutoreleaseContextMessage = ({
  templateName,
  selectedPast,
  onViewLastSubmitted,
  returnToId,
}) => {
  if (!selectedPast) return null;

  const sponsor = selectedPast.sponsor_name || "another sponsor";
  const ago = utcTimeAgo(selectedPast.release_date);
  const pastVqqName = selectedPast.name
    ? appendVqqLocation(
        formatVqqName(selectedPast.name),
        selectedPast.location_city,
        selectedPast.location_state
      )
    : formatVqqName(templateName) || "your last submitted VQQ";
  // The Details route is keyed on the HC questionnaire_id (int), not the SponsorRFIResponse
  // Guid PK. past_submissions are filtered server-side to have questionnaire_id != null, so
  // this is always present.
  const pastDetailsPath = returnToId
    ? `/RFI/${selectedPast.questionnaire_id}/Details?returnTo=${returnToId}`
    : `/RFI/${selectedPast.questionnaire_id}/Details`;

  return (
    <div className="flex items-start gap-3 text-sm text-gray-800">
      <InformationCircleIcon
        className="h-5 w-5 text-indigo-500 shrink-0 mt-0.5"
        aria-hidden="true"
      />
      <p className="leading-relaxed">
        You submitted your responses to{" "}
        <Link
          to={pastDetailsPath}
          className="text-indigo-700 underline font-medium hover:text-indigo-800"
        >
          {pastVqqName}
        </Link>{" "}
        for {sponsor} {ago}, which uses the same questionnaire. Autorelease accepts the
        sponsor's qualification questionnaire request,
        populates it with your last approved and submitted responses, and submits
        the auto-completed VQQ to the sponsor — all in one click.{" "}
        <button
          type="button"
          onClick={onViewLastSubmitted}
          className="text-indigo-700 underline font-medium hover:text-indigo-800 italic"
        >
          Click here to view and verify your last submitted responses.
        </button>
      </p>
    </div>
  );
};

export default AutoreleaseContextMessage;
